
    import { getUserProfile, updateUserProfile, updatePassword } from '/src/js/auth.js';
    import { populateCountrySelect } from '/src/js/countries.js';

    const API_BASE = window.location.hostname === 'localhost' ? 'http://localhost:3000/api/v1' : 'https://coinlance.org/api/v1';

    // Highlight active navigation link
    const currentPage = 'profile';
    const navLinks = document.querySelectorAll('[data-page]');
    
    navLinks.forEach(link => {
      if (link.getAttribute('data-page') === currentPage) {
        link.classList.remove('nav-link');
        link.classList.add('nav-link-active');
      }
    });

    // Check if user is logged in
    const token = localStorage.getItem('token') || localStorage.getItem('authToken');
    console.log('[Profile] Checking authentication...');
    console.log('[Profile] Token from localStorage:', token ? token.substring(0, 20) + '...' : 'NONE');
    
    if (!token) {
      console.error('[Profile] No token found, redirecting to login');
      window.location.href = '/login.html';
    } else {
      console.log('[Profile] Token found, loading profile...');
      // Show page content after authentication check passes
      document.querySelector('.page-content').classList.add('authenticated');
    }

    // Load user profile
    async function loadProfile() {
      try {
        const profile = await getUserProfile();
        if (!profile) {
          console.error('[Profile] Failed to load profile, getUserProfile returned null');
          // Don't redirect here, getUserProfile already handles it
          return;
        }
        
        // Update UI with profile data
        document.getElementById('userName').textContent = `${profile.firstName} ${profile.lastName}`;
        document.getElementById('userEmail').textContent = profile.email;
        document.getElementById('userEmailDisplay').textContent = profile.email;
        document.getElementById('userInitials').textContent = `${profile.firstName[0]}${profile.lastName[0]}`.toUpperCase();
        
        // Update form fields
        document.getElementById('editFirstName').value = profile.firstName;
        document.getElementById('editLastName').value = profile.lastName;
        document.getElementById('editEmail').value = profile.email;
        document.getElementById('editPhone').value = profile.phone || '';
        
        // Populate country dropdown and set value
        populateCountrySelect(document.getElementById('editCountry'), profile.country || 'US');
        
        // Display profile picture if it exists
        if (profile.profilePicture) {
          displayProfilePicture(profile.profilePicture);
        }
        
        // Update verification status
        const verificationBadge = document.getElementById('verificationBadge');
        const verificationStatus = document.getElementById('verificationStatus');
        
        if (profile.verified) {
          verificationBadge.className = 'mt-3 inline-flex items-center px-3 py-1 rounded-full text-sm bg-success-500/20 text-success-500';
          verificationStatus.textContent = 'Verified';
          
          // Update Verification Tab
          const verificationStatusCard = document.getElementById('verificationStatusCard');
          verificationStatusCard.className = 'p-6 bg-success-500/10 border border-success-500 rounded-lg mb-6';
          verificationStatusCard.innerHTML = `
            <div class="flex items-start">
              <svg class="w-6 h-6 text-success-500 mt-1 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <div>
                <h4 class="font-semibold text-lg mb-2 text-success-500">Account Verified</h4>
                <p class="text-sm text-neutral-300">Your account has been successfully verified and approved by admin. You now have full access to all features.</p>
              </div>
            </div>
          `;
          
          // Update Email Verification Row
          const emailVerificationRow = document.getElementById('emailVerificationRow');
          if (emailVerificationRow) {
            emailVerificationRow.innerHTML = `
              <div class="flex items-center">
                <svg class="w-5 h-5 text-success-500 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                <div>
                  <div class="font-medium">Email Verification</div>
                  <div class="text-sm text-neutral-400">Verified and approved</div>
                </div>
              </div>
              <span class="badge-success">Verified</span>
            `;
          }
        } else {
          verificationBadge.className = 'mt-3 inline-flex items-center px-3 py-1 rounded-full text-sm bg-warning-500/20 text-warning-500';
          verificationStatus.textContent = 'Pending Verification';
          
          // Update Verification Tab
          const verificationStatusCard = document.getElementById('verificationStatusCard');
          verificationStatusCard.className = 'p-6 bg-warning-500/10 border border-warning-500 rounded-lg mb-6';
          verificationStatusCard.innerHTML = `
            <div class="flex items-start">
              <svg class="w-6 h-6 text-warning-500 mt-1 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <div>
                <h4 class="font-semibold text-lg mb-2">Verification Pending</h4>
                <p class="text-sm text-neutral-300">Your account registration has been submitted and is awaiting admin approval. An OTP has been sent to the admin for verification. You will receive an email notification once your account is approved.</p>
                <p class="text-sm text-neutral-400 mt-2">Typical verification time: 24-48 hours</p>
              </div>
            </div>
          `;
          
          // Update Email Verification Row
          const emailVerificationRow = document.getElementById('emailVerificationRow');
          if (emailVerificationRow) {
            emailVerificationRow.innerHTML = `
              <div class="flex items-center">
                <svg class="w-5 h-5 text-warning-500 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                <div>
                  <div class="font-medium">Email Verification</div>
                  <div class="text-sm text-neutral-400">Pending admin approval</div>
                </div>
              </div>
              <span class="badge-warning">Pending</span>
            `;
          }
        }
        
        // Set account created date
        if (profile.createdAt) {
          document.getElementById('accountCreatedDate').textContent = new Date(profile.createdAt).toLocaleDateString();
        }
      } catch (error) {
        console.error('[Profile] Error in loadProfile:', error);
        // Show error message to user instead of just failing silently
        alert('Failed to load profile. Please try refreshing the page or logging in again.');
      }
    }

    async function loadTradeCount() {
      const token = localStorage.getItem('authToken') || localStorage.getItem('token');
      
      try {
        const response = await fetch(`${API_BASE}/auth/user-trades`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        
        if (response.ok) {
          const { trades } = await response.json();
          const tradeCount = trades ? trades.length : 0;
          document.getElementById('profileTotalTrades').textContent = tradeCount;
        }
      } catch (error) {
        // Silently fail - endpoint not implemented yet
        document.getElementById('profileTotalTrades').textContent = 0;
      }
    }

    loadProfile();
    loadAccountLevel();
    loadTradeCount();

    // Load and display wallet balance
    async function loadWalletBalance() {
      try {
        // Fetch wallet data
        const walletsResponse = await fetch(`${API_BASE}/wallets`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (!walletsResponse.ok) {
          console.error('Failed to fetch wallets');
          return;
        }

        const walletsData = await walletsResponse.json();
        const wallets = walletsData.wallets || [];

        // Fetch market prices
        const marketsResponse = await fetch(`${API_BASE}/markets`);
        let marketPrices = { BTC: 0, ETH: 0, USDT: 1 };

        if (marketsResponse.ok) {
          const marketsData = await marketsResponse.json();
          const markets = marketsData.markets || [];

          // Extract prices
          const btcMarket = markets.find(m => m.symbol === 'BTC-USDT');
          const ethMarket = markets.find(m => m.symbol === 'ETH-USDT');

          if (btcMarket) marketPrices.BTC = parseFloat(btcMarket.lastPrice) || 0;
          if (ethMarket) marketPrices.ETH = parseFloat(ethMarket.lastPrice) || 0;
        }

        // Calculate total balance in USD
        let totalUSD = 0;
        wallets.forEach(wallet => {
          const amount = parseFloat(wallet.balance) || 0;
          const currency = wallet.currency.toUpperCase();
          
          if (currency === 'USDT') {
            totalUSD += amount;
          } else if (currency === 'BTC' && marketPrices.BTC > 0) {
            totalUSD += amount * marketPrices.BTC;
          } else if (currency === 'ETH' && marketPrices.ETH > 0) {
            totalUSD += amount * marketPrices.ETH;
          }
        });

        // Calculate BTC equivalent
        const btcEquivalent = marketPrices.BTC > 0 ? totalUSD / marketPrices.BTC : 0;

        // Update the profile overview
        const balanceElement = document.getElementById('profileTotalBalance');
        if (balanceElement) {
          balanceElement.innerHTML = `$${totalUSD.toFixed(2)}<div class="text-sm text-neutral-400 font-normal mt-1">≈ ${btcEquivalent.toFixed(8)} BTC</div>`;
        }

      } catch (error) {
        console.error('Failed to load wallet balance:', error);
      }
    }

    loadWalletBalance();
    // Refresh balance every 30 seconds
    setInterval(loadWalletBalance, 30000);

    // Tab switching
    window.showTab = function(tabName) {
      // Hide all tabs
      document.querySelectorAll('.profile-content').forEach(tab => {
        tab.classList.add('hidden');
      });
      
      // Remove active class from all buttons
      document.querySelectorAll('.profile-tab-btn').forEach(btn => {
        btn.classList.remove('active', 'bg-regal-gold', 'text-onyx-black');
      });
      
      // Show selected tab
      document.getElementById(tabName + 'Tab').classList.remove('hidden');
      
      // Add active class to selected button
      const activeBtn = document.querySelector(`[data-tab="${tabName}"]`);
      activeBtn.classList.add('active', 'bg-regal-gold', 'text-onyx-black');
    }

    // Account form submission
    document.getElementById('accountForm').addEventListener('submit', async (e) => {
      e.preventDefault();
      const messageDiv = document.getElementById('accountUpdateMessage');
      
      const updateData = {
        firstName: document.getElementById('editFirstName').value,
        lastName: document.getElementById('editLastName').value,
        phone: document.getElementById('editPhone').value,
        country: document.getElementById('editCountry').value
      };

      try {
        const result = await updateUserProfile(updateData);
        if (result.success) {
          messageDiv.className = 'p-4 rounded-lg bg-success-500/10 text-success-500 border border-success-500';
          messageDiv.textContent = 'Profile updated successfully!';
          messageDiv.classList.remove('hidden');
          loadProfile();
        } else {
          messageDiv.className = 'p-4 rounded-lg bg-error-500/10 text-error-500 border border-error-500';
          messageDiv.textContent = result.message || 'Failed to update profile';
          messageDiv.classList.remove('hidden');
        }
      } catch (error) {
        messageDiv.className = 'p-4 rounded-lg bg-error-500/10 text-error-500 border border-error-500';
        messageDiv.textContent = 'An error occurred';
        messageDiv.classList.remove('hidden');
      }
    });

    // Password form submission
    document.getElementById('passwordForm').addEventListener('submit', async (e) => {
      e.preventDefault();
      const messageDiv = document.getElementById('passwordUpdateMessage');
      
      const currentPassword = document.getElementById('currentPassword').value;
      const newPassword = document.getElementById('newPassword').value;
      const confirmPassword = document.getElementById('confirmNewPassword').value;

      if (newPassword !== confirmPassword) {
        messageDiv.className = 'p-4 rounded-lg bg-error-500/10 text-error-500 border border-error-500';
        messageDiv.textContent = 'New passwords do not match';
        messageDiv.classList.remove('hidden');
        return;
      }

      try {
        const result = await updatePassword(currentPassword, newPassword);
        if (result.success) {
          messageDiv.className = 'p-4 rounded-lg bg-success-500/10 text-success-500 border border-success-500';
          messageDiv.textContent = 'Password updated successfully!';
          messageDiv.classList.remove('hidden');
          document.getElementById('passwordForm').reset();
        } else {
          messageDiv.className = 'p-4 rounded-lg bg-error-500/10 text-error-500 border border-error-500';
          messageDiv.textContent = result.message || 'Failed to update password';
          messageDiv.classList.remove('hidden');
        }
      } catch (error) {
        messageDiv.className = 'p-4 rounded-lg bg-error-500/10 text-error-500 border border-error-500';
        messageDiv.textContent = 'An error occurred';
        messageDiv.classList.remove('hidden');
      }
    });

    // Profile Picture Upload
    document.getElementById('profilePictureInput').addEventListener('change', async (e) => {
      const file = e.target.files[0];
      const messageDiv = document.getElementById('profilePictureMessage');
      
      if (!file) return;
      
      // Validate file size (2MB max)
      if (file.size > 2 * 1024 * 1024) {
        messageDiv.className = 'mt-2 p-2 rounded text-sm bg-error-500/10 text-error-500';
        messageDiv.textContent = 'Image size must be less than 2MB';
        messageDiv.classList.remove('hidden');
        return;
      }
      
      // Validate file type
      if (!['image/jpeg', 'image/jpg', 'image/png'].includes(file.type)) {
        messageDiv.className = 'mt-2 p-2 rounded text-sm bg-error-500/10 text-error-500';
        messageDiv.textContent = 'Only JPG, JPEG, and PNG images are allowed';
        messageDiv.classList.remove('hidden');
        return;
      }
      
      // Read and convert to base64
      const reader = new FileReader();
      reader.onload = async (event) => {
        const base64Image = event.target.result;
        
        try {
          const token = localStorage.getItem('token') || localStorage.getItem('authToken');
          const response = await fetch((window.location.hostname === 'localhost' ? 'http://localhost:3000' : 'https://coinlance.org') + '/api/v1/users/profile-picture', {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ profilePicture: base64Image })
          });
          
          const result = await response.json();
          
          if (response.ok) {
            displayProfilePicture(base64Image);
            messageDiv.className = 'mt-2 p-2 rounded text-sm bg-success-500/10 text-success-500';
            messageDiv.textContent = 'Profile picture updated successfully!';
            messageDiv.classList.remove('hidden');
            setTimeout(() => messageDiv.classList.add('hidden'), 3000);
          } else {
            messageDiv.className = 'mt-2 p-2 rounded text-sm bg-error-500/10 text-error-500';
            messageDiv.textContent = result.error || 'Failed to upload profile picture';
            messageDiv.classList.remove('hidden');
          }
        } catch (error) {
          messageDiv.className = 'mt-2 p-2 rounded text-sm bg-error-500/10 text-error-500';
          messageDiv.textContent = 'An error occurred while uploading';
          messageDiv.classList.remove('hidden');
        }
      };
      
      reader.readAsDataURL(file);
    });
    
    // Remove Profile Picture
    document.getElementById('removeProfilePicture').addEventListener('click', async () => {
      const messageDiv = document.getElementById('profilePictureMessage');
      
      try {
        const token = localStorage.getItem('token') || localStorage.getItem('authToken');
        const response = await fetch((window.location.hostname === 'localhost' ? 'http://localhost:3000' : 'https://coinlance.org') + '/api/v1/users/profile-picture', {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        const result = await response.json();
        
        if (response.ok) {
          removeProfilePicture();
          messageDiv.className = 'mt-2 p-2 rounded text-sm bg-success-500/10 text-success-500';
          messageDiv.textContent = 'Profile picture removed';
          messageDiv.classList.remove('hidden');
          setTimeout(() => messageDiv.classList.add('hidden'), 3000);
        } else {
          messageDiv.className = 'mt-2 p-2 rounded text-sm bg-error-500/10 text-error-500';
          messageDiv.textContent = result.error || 'Failed to remove profile picture';
          messageDiv.classList.remove('hidden');
        }
      } catch (error) {
        messageDiv.className = 'mt-2 p-2 rounded text-sm bg-error-500/10 text-error-500';
        messageDiv.textContent = 'An error occurred';
        messageDiv.classList.remove('hidden');
      }
    });
    
    function displayProfilePicture(base64Image) {
      // Show in sidebar
      const sidebarImg = document.getElementById('sidebarProfilePicture');
      const sidebarInitials = document.getElementById('userInitials');
      sidebarImg.src = base64Image;
      sidebarImg.classList.remove('hidden');
      sidebarInitials.classList.add('hidden');
      
      // Show in settings preview
      const previewImg = document.getElementById('profilePictureImg');
      const previewInitials = document.getElementById('profileInitials');
      previewImg.src = base64Image;
      previewImg.classList.remove('hidden');
      previewInitials.classList.add('hidden');
      
      // Show remove button
      document.getElementById('removeProfilePicture').classList.remove('hidden');
    }
    
    function removeProfilePicture() {
      // Hide images, show initials
      const sidebarImg = document.getElementById('sidebarProfilePicture');
      const sidebarInitials = document.getElementById('userInitials');
      sidebarImg.classList.add('hidden');
      sidebarInitials.classList.remove('hidden');
      
      const previewImg = document.getElementById('profilePictureImg');
      const previewInitials = document.getElementById('profileInitials');
      previewImg.classList.add('hidden');
      previewInitials.classList.remove('hidden');
      
      // Hide remove button
      document.getElementById('removeProfilePicture').classList.add('hidden');
    }
    
    // Account Level functions
    async function loadAccountLevel() {
      const token = localStorage.getItem('authToken') || localStorage.getItem('token');
      
      try {
        // Load user profile
        const profileRes = await fetch(`${API_BASE}/users/profile`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        
        if (profileRes.ok) {
          const { user } = await profileRes.json();
          updateAccountLevelDisplay(user.accountLevel || 'starter');
        }
        
        // Load upgrade requests history
        const requestsRes = await fetch(`${API_BASE}/auth/upgrade-requests`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        
        if (requestsRes.ok) {
          const { requests } = await requestsRes.json();
          displayUpgradeRequests(requests || []);
        }
      } catch (error) {
        console.error('Error loading account level:', error);
        // Silently fail - use default starter level
        updateAccountLevelDisplay('starter');
      }
    }
    
    function displayUpgradeRequests(requests) {
      const container = document.getElementById('upgradeRequestsList');
      if (!container) return;
      
      if (requests.length === 0) {
        container.innerHTML = '<div class="text-neutral-400 text-center py-6">No upgrade requests yet</div>';
        return;
      }
      
      const statusColors = {
        pending: 'bg-yellow-500/10 text-yellow-500 border-yellow-500',
        approved: 'bg-green-500/10 text-green-500 border-green-500',
        rejected: 'bg-red-500/10 text-red-500 border-red-500'
      };
      
      container.innerHTML = requests.map(req => `
        <div class="p-4 bg-neutral-800 rounded-lg border border-neutral-700">
          <div class="flex justify-between items-start mb-2">
            <div>
              <span class="font-semibold">${req.currentLevel} → ${req.requestedLevel}</span>
              <div class="text-sm text-neutral-400 mt-1">${new Date(req.createdAt).toLocaleDateString()}</div>
            </div>
            <span class="px-3 py-1 rounded-full text-xs font-semibold border ${statusColors[req.status] || ''}">${req.status.toUpperCase()}</span>
          </div>
          ${req.userComment ? `<div class="text-sm text-neutral-400 mt-2">Your comment: ${req.userComment}</div>` : ''}
          ${req.adminComment ? `<div class="text-sm text-success-500 mt-2">Admin response: ${req.adminComment}</div>` : ''}
        </div>
      `).join('');
    }
    
    function updateAccountLevelDisplay(level) {
      const levelNames = {
        starter: 'Starter',
        gold: 'Gold',
        premium: 'Premium'
      };
      
      const levelDescriptions = {
        starter: 'Free tier with basic features',
        gold: 'Enhanced features for serious traders',
        premium: 'Ultimate experience for professional traders'
      };
      
      const levelColors = {
        starter: 'border-neutral-500',
        gold: 'border-yellow-600',
        premium: 'border-purple-600'
      };

      // Update Account Overview section
      const profileAccountLevel = document.getElementById('profileAccountLevel');
      if (profileAccountLevel) {
        profileAccountLevel.textContent = levelNames[level] || 'Starter';
        // Add color based on level
        profileAccountLevel.className = `text-2xl font-bold ${level === 'gold' ? 'text-yellow-500' : level === 'premium' ? 'text-purple-500' : ''}`;
      }
      
      const currentLevelDisplay = document.getElementById('currentLevelDisplay');
      const currentLevelName = document.getElementById('currentLevelName');
      
      currentLevelName.textContent = levelNames[level] || 'Starter';
      currentLevelDisplay.className = `p-6 bg-gradient-to-r from-neutral-800 to-neutral-700 rounded-lg border ${levelColors[level] || 'border-neutral-500'}`;
      currentLevelDisplay.querySelector('.text-sm').textContent = levelDescriptions[level] || 'Free tier with basic features';
      
      // Update button states
      if (level === 'starter') {
        document.getElementById('requestGoldBtn').disabled = false;
        document.getElementById('requestGoldBtn').classList.remove('opacity-50', 'cursor-not-allowed');
        document.getElementById('requestPremiumBtn').disabled = false;
        document.getElementById('requestPremiumBtn').classList.remove('opacity-50', 'cursor-not-allowed');
      } else if (level === 'gold') {
        document.getElementById('requestGoldBtn').textContent = 'Current Level';
        document.getElementById('requestGoldBtn').disabled = true;
        document.getElementById('requestGoldBtn').classList.add('opacity-50', 'cursor-not-allowed');
        document.getElementById('requestPremiumBtn').disabled = false;
        document.getElementById('requestPremiumBtn').classList.remove('opacity-50', 'cursor-not-allowed');
      } else if (level === 'premium') {
        document.getElementById('requestGoldBtn').textContent = 'Lower Level';
        document.getElementById('requestGoldBtn').disabled = true;
        document.getElementById('requestGoldBtn').classList.add('opacity-50', 'cursor-not-allowed');
        document.getElementById('requestPremiumBtn').textContent = 'Current Level';
        document.getElementById('requestPremiumBtn').disabled = true;
        document.getElementById('requestPremiumBtn').classList.add('opacity-50', 'cursor-not-allowed');
      }
    }
    
    // Store the requested level globally
    let requestedUpgradeLevel = '';
    
    function requestUpgrade(level) {
      // Store the level for later use
      requestedUpgradeLevel = level;
      
      // Update modal title
      const levelNames = { gold: 'Gold', premium: 'Premium' };
      document.getElementById('modalUpgradeLevel').textContent = `to ${levelNames[level]} Level`;
      
      // Clear previous input and message
      document.getElementById('upgradeRequestReason').value = '';
      document.getElementById('upgradeModalMessage').classList.add('hidden');
      
      // Prevent body scroll - lock both html and body
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${window.scrollY}px`;
      
      // Show the modal with animation
      const modal = document.getElementById('upgradeRequestModal');
      modal.classList.remove('hidden');
      
      // Animate in
      setTimeout(() => {
        modal.querySelector('.bg-neutral-800').style.transform = 'scale(1)';
        modal.querySelector('.bg-neutral-800').style.opacity = '1';
      }, 10);
    }
    
    function closeUpgradeModal() {
      const modal = document.getElementById('upgradeRequestModal');
      
      // Animate out
      modal.querySelector('.bg-neutral-800').style.transform = 'scale(0.95)';
      modal.querySelector('.bg-neutral-800').style.opacity = '0';
      
      setTimeout(() => {
        modal.classList.add('hidden');
        
        // Restore body scroll and position
        const scrollY = document.body.style.top;
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      }, 200);
    }
    
    async function submitUpgradeRequest() {
      const token = localStorage.getItem('authToken') || localStorage.getItem('token');
      const reason = document.getElementById('upgradeRequestReason').value.trim();
      const messageDiv = document.getElementById('upgradeModalMessage');
      const submitBtn = document.getElementById('submitUpgradeBtn');
      
      // Map frontend level names to backend level values
      const levelMap = {
        'gold': 'level_2',
        'premium': 'level_3'
      };
      
      // Disable button and show loading state
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';
      
      try {
        const response = await fetch(`${API_BASE}/auth/upgrade-request`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            requestedLevel: requestedUpgradeLevel,
            comment: reason || ''
          })
        });
        
        const result = await response.json();
        
        if (response.ok) {
          // Show success message
          messageDiv.className = 'p-3 rounded-lg text-sm bg-success-500/10 text-success-500 border border-success-500';
          messageDiv.innerHTML = `
            <div class="flex items-center">
              <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              Request submitted successfully! You'll be notified when reviewed.
            </div>
          `;
          messageDiv.classList.remove('hidden');
          
          // Close modal after delay and reload
          setTimeout(() => {
            closeUpgradeModal();
            loadAccountLevel(); // Reload to show the new request
          }, 2000);
        } else {
          // Show error message
          messageDiv.className = 'p-3 rounded-lg text-sm bg-error-500/10 text-error-500 border border-error-500';
          messageDiv.innerHTML = `
            <div class="flex items-center">
              <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              ${result.error || 'Failed to submit upgrade request'}
            </div>
          `;
          messageDiv.classList.remove('hidden');
          
          // Re-enable button
          submitBtn.disabled = false;
          submitBtn.textContent = 'Submit Request';
        }
      } catch (error) {
        console.error('Error requesting upgrade:', error);
        messageDiv.className = 'p-3 rounded-lg text-sm bg-error-500/10 text-error-500 border border-error-500';
        messageDiv.innerHTML = `
          <div class="flex items-center">
            <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            An error occurred while submitting your request
          </div>
        `;
        messageDiv.classList.remove('hidden');
        
        // Re-enable button
        submitBtn.disabled = false;
        submitBtn.textContent = 'Submit Request';
      }
    }
    
    // Make functions global
    window.requestUpgrade = requestUpgrade;
    window.closeUpgradeModal = closeUpgradeModal;
    window.submitUpgradeRequest = submitUpgradeRequest;
    
    // Close modal on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !document.getElementById('upgradeRequestModal').classList.contains('hidden')) {
        closeUpgradeModal();
      }
    });
    
    // Close modal on backdrop click
    document.getElementById('upgradeRequestModal').addEventListener('click', (e) => {
      if (e.target.id === 'upgradeRequestModal') {
        closeUpgradeModal();
      }
    });
    
    // Make functions global
    window.requestUpgrade = requestUpgrade;

    // Logout
    document.getElementById('logoutBtn').addEventListener('click', () => {
      localStorage.removeItem('token');
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      window.location.href = '/login.html';
    });
  